// src/pages/MapPage.js
import React from 'react';
import { MapContainer, TileLayer, ZoomControl } from 'react-leaflet';
import { useTranslation } from 'react-i18next';
import { FaSearchPlus } from 'react-icons/fa';
import 'leaflet/dist/leaflet.css';
import '../css/mapPage.css';

const MapPage = () => {
    const { t } = useTranslation();

    return (
        <div className="map-page">
            <section className="map-header">
                <div className="sp-container">
                    <div className="sp-section-head map-head">
                        <span className="sp-eyebrow">{t('map.eyebrow')}</span>
                        <h1 className="sp-title">{t('map.title')}</h1>
                        <div className="line-wrapper">
                            <img src="images/sp-line.png" alt="Sp_line" className="line"/>
                        </div>
                        <p className="map-subtitle">{t('map.subtitle')}</p>
                    </div>
                </div>
            </section>

            <section className="map-main">
                <div className="sp-container">
                    <div className="map-shell">
                        <MapContainer
                            center={[0, 0]}
                            zoom={2}
                            minZoom={1}
                            maxZoom={4}
                            className="map-container"
                            zoomControl={false}
                        >
                            <TileLayer
                                url="/images/map/terrain/{z}/{y}/t_{x}.jpg"
                                tileSize={256}
                                noWrap={true}
                                errorTileUrl="/fallback_tile.jpg"
                            />
                            <ZoomControl position="bottomright" />
                        </MapContainer>
                        <div className="map-hint">
                            <FaSearchPlus />
                            <span>{t('map.zoomHint')}</span>
                        </div>
                    </div>

                    <div className="map-features">
                        <div className="map-feature">
                            <span className="map-feature-num">01</span>
                            <h3>{t('map.featureDropTitle')}</h3>
                            <p>{t('map.featureDropDesc')}</p>
                        </div>
                        <div className="map-feature">
                            <span className="map-feature-num">02</span>
                            <h3>{t('map.featureTerrainTitle')}</h3>
                            <p>{t('map.featureTerrainDesc')}</p>
                        </div>
                        <div className="map-feature">
                            <span className="map-feature-num">03</span>
                            <h3>{t('map.featureZoneTitle')}</h3>
                            <p>{t('map.featureZoneDesc')}</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default MapPage;
